import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAudio } from '@fortawesome/pro-light-svg-icons/faFileAudio';
import { TypedMemo } from '../../../common/types';
import { catalogSongMessages } from './catalogSongMessages';
import { Panel } from '../../../music24/components/primitives/Panel';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the song files; each part uses its own slice of it */
import styles from './SongFiles.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface PickedMasterFileProps {
  file: File;
  /** True while the file waits for the rights box (design g1). */
  isWaitingForRights: boolean;
  onRemove: () => void;
  disabled?: boolean;
}

/** A master the user picked that is not sent yet (designs f3, g1, k1). */
const PickedMasterFileComponent: React.FC<PickedMasterFileProps> = ({
  file,
  isWaitingForRights,
  onRemove,
  disabled = false,
}) => {
  const intl = useIntl();
  const size = intl.formatNumber(file.size / (1024 * 1024), { maximumFractionDigits: 1 });

  return (
    <Panel nested className={styles.file}>
      <span className={styles.dropIcon}>
        <FontAwesomeIcon icon={faFileAudio} />
      </span>
      <div className={styles.grow}>
        <span className={styles.strong}>{file.name}</span>
        <span className={styles.mono}>
          {intl.formatMessage(isWaitingForRights ? catalogSongMessages.picked : catalogSongMessages.pickedReady, {
            size,
          })}
        </span>
      </div>
      <button type="button" className={styles.linkButton} disabled={disabled} onClick={onRemove}>
        {intl.formatMessage(isWaitingForRights ? catalogSongMessages.cancel : catalogSongMessages.remove)}
      </button>
    </Panel>
  );
};

export const PickedMasterFile = TypedMemo(PickedMasterFileComponent);
